import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import { BrushawayHeader } from '@ui/molecules/Brushaway';
import { namespace } from '../constants';
function EmbeddedDeficiencyDetailHeader({ deficiencyId, inspectionId = null, secondaryActions, fields }) {
    const title = (React.createElement("div", { className: "embedded-deficiency-detail__header-title" },
        React.createElement(Text, { variant: "medium" },
            `${translate('title', { namespace })} #${deficiencyId}`,
            ' ',
            inspectionId != null && (React.createElement("a", { href: `/inspections/${inspectionId}`, rel: "noopener noreferrer", target: "_blank" },
                React.createElement(Text, { variant: "custom-medium" }, `${translate('inspection_title', { namespace })} #${inspectionId}`))))));
    return (React.createElement(BrushawayHeader, { title: title, secondaryActions: secondaryActions, fields: fields, divider: false, closeLabel: translate('close', { namespace: 'generic' }), fieldsLabel: translate('header_fields', { namespace }), className: "embedded-deficiency-detail__header" }));
}
export default EmbeddedDeficiencyDetailHeader;
